import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { Drawer, IconButton } from "@mui/material";
import { Menu as MenuIcon } from "@mui/icons-material";
import { useSelector, useDispatch } from "react-redux";
import { logoutUser } from "../redux/authSlice";
import Sidebar from "./Sidebar";
import "./Navbars.css";
import iconImg from "./../assets/images/icon.webp";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faShoppingCart, faSignInAlt, faUserPlus } from '@fortawesome/free-solid-svg-icons';

const Navbars = () => {
  const { isAuthenticated } = useSelector((state) => state.auth);
  const [isSidebarOpen, setIsSidebarOpen] = React.useState(false);
  const dispatch = useDispatch(); // Ensure dispatch is used
  const navigate = useNavigate(); // Ensure navigate is used

  const toggleSidebar = () => setIsSidebarOpen((prev) => !prev);

  const handleLogout = () => {
    console.log("Logout button clicked"); // Debugging
    dispatch(logoutUser(navigate)); // Dispatch logout properly
  };

  return (
    <>
      <header className="navbar navbar-expand-lg navbar-dark bg-dark">
        <div className="container">
          <Link to="/" className="navbar-brand d-flex align-items-center">
            <img src={iconImg} alt="Logo" width="40" height="32" className="me-2 rounded-circle" />
            E-Commerce
          </Link>

          <IconButton sx={{ color: "white" }} className="d-lg-none" onClick={toggleSidebar} aria-label="menu">
            <MenuIcon />
          </IconButton>

          <div className="collapse navbar-collapse d-none d-lg-flex">
            <ul className="navbar-nav me-auto">
              <li className="nav-item">
                <Link className="nav-link" to="/">Home</Link>
              </li>
              <li className="nav-item">
                <Link className="nav-link" to="/feedback">Feedback</Link>
              </li>
            </ul>

            <div className="d-flex align-items-center">
              {isAuthenticated ? (
                <button className="btn btn-warning me-2" onClick={handleLogout}>
                  Logout
                </button>
              ) : (
                <>
                  <Link to="/login" className="btn btn-outline-light me-2">
                    <FontAwesomeIcon icon={faSignInAlt} className="me-2" />
                    Login
                  </Link>
                  <Link to="/register" className="btn btn-primary me-2">
                    <FontAwesomeIcon icon={faUserPlus} className="me-2" />
                    Register
                  </Link>
                </>
              )}
              <Link to="/cart" className="btn btn-outline-light position-relative">
                <FontAwesomeIcon icon={faShoppingCart} />
              </Link>
            </div>
          </div>
        </div>
      </header>

      <Drawer anchor="left" open={isSidebarOpen} onClose={toggleSidebar}>
        <Sidebar toggleSidebar={toggleSidebar} isAuthenticated={isAuthenticated} handleLogout={handleLogout} />
      </Drawer>
    </>
  );
};

export default Navbars;
